import { render, staticRenderFns } from "./FloatingContact.vue?vue&type=template&id=a8694604&scoped=true"
import script from "./FloatingContact.vue?vue&type=script&lang=js"
export * from "./FloatingContact.vue?vue&type=script&lang=js"
import style0 from "./FloatingContact.vue?vue&type=style&index=0&id=a8694604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8694604",
  null
  
)

export default component.exports